export const getResumeList = state => state.resumes && state.resumes.ResumeList;
